import { render, staticRenderFns } from "./createOrUpdate.vue?vue&type=template&id=1aa9a39b&scoped=true"
import script from "./createOrUpdate.vue?vue&type=script&lang=js"
export * from "./createOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./createOrUpdate.vue?vue&type=style&index=0&id=1aa9a39b&prod&lang=scss&scoped=true"
import style1 from "./createOrUpdate.vue?vue&type=style&index=1&id=1aa9a39b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa9a39b",
  null
  
)

export default component.exports